import { FC } from 'react'
import { FormikSelect } from '../../../../components/formik-component'
import { Select } from 'antd'
import { EmployeeLevelEnum } from '../../../../types'
import { useTranslation } from 'react-i18next'
const { Option } = Select

interface EmployeeLevelSelectProps {
  currentEmployeeLevel: EmployeeLevelEnum
  name: string
  isEmployeeLevelValidationEnabled: boolean
  disabled?: boolean
  employeeLevels: EmployeeLevelEnum[]
}

export const EmployeeLevelSelect: FC<EmployeeLevelSelectProps> = ({
  currentEmployeeLevel,
  name,
  isEmployeeLevelValidationEnabled,
  disabled = false,
  employeeLevels,
}) => {
  const [t] = useTranslation()

  const currentEmployeeLevels = (): string[] => {
    const _employeeLevels = !!employeeLevels ? [...employeeLevels] : []

    const indexOfCurrentEmployeeLevel: number = _employeeLevels.indexOf(currentEmployeeLevel)
    const levelsOptions =
      indexOfCurrentEmployeeLevel > -1
        ? isEmployeeLevelValidationEnabled
          ? _employeeLevels.splice(indexOfCurrentEmployeeLevel + 1)
          : _employeeLevels
        : []
    if (
      isEmployeeLevelValidationEnabled &&
      _employeeLevels.includes(EmployeeLevelEnum.Spr) &&
      currentEmployeeLevel === EmployeeLevelEnum.Sm
    ) {
      levelsOptions.unshift(EmployeeLevelEnum.Spr)
    } else if (
      isEmployeeLevelValidationEnabled &&
      _employeeLevels.includes(EmployeeLevelEnum.Pr) &&
      currentEmployeeLevel === EmployeeLevelEnum.M
    ) {
      levelsOptions.unshift(EmployeeLevelEnum.Pr)
    }
    return levelsOptions
  }

  return (
    <FormikSelect
      name={name + '.employeeLevel'}
      placeholder={t(`employee.contract.level.${currentEmployeeLevel}`)}
      size="small"
      style={{ width: '100%' }}
      allowClear
      data-e2e-employee-level-dropdown
      disabled={disabled}
    >
      {currentEmployeeLevels().map((level, index) => (
        <Option data-e2e-employee-level={level} value={level} key={level + index} disabled={level === currentEmployeeLevel}>
          {t(`employee.contract.level.${level}`)}
        </Option>
      ))}
    </FormikSelect>
  )
}
